export default __webpack_public_path__ + "static/media/handText2.2bb5dbe3.png";